import ApiService from '@/services/api.service'

const UtilsService = {
  
  getExecuteSP(request) {
      return ApiService.post('/Utils/ExecuteSP', request); 
  },

  getUserRestrictions(userId) {
    return ApiService.get(`/Utils/UserRestrictions/${userId}`);
  }
}
  
export default UtilsService;